import React from 'react'
import { Card, CardGroup } from 'react-bootstrap'

const ArchitecturalModeling = () => {
  return (
    <>
        <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'>Architectural Modeling</Card.Title>
                    <Card.Text className='architectural-modeling-text'>
                        The a rchitecture, engineering and construction sector long ago adopted 3D floor plans and often physical models to share architects’ and designers’ visions with clients. S oftware tools increasingly allow the immersive viewing of CAD (computer aided design) files in VR headsets and virtual walk throughs, including with real time rendering of lighting, time of day and even weather. With our expertise in artist - created 3D models of existing buildings that have not been digitally desig ned, we can bring the same benefits to pre - built environments. 
                        <br />
                        <br /> As we move toward creating Digital Twins of all existing physical environments, we can create fully immersive human - scale virtual campuses and tours that allow anyone to visit any location. 
                        <br />
                        <br /> Here is are two examples from a University visitor center’s virtual campus tour.
                        <br />
                        <br />
                    </Card.Text>
                    <CardGroup className='architectural-modeling-cardgroup'>
                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                            <Card.Img className='architectural-modeling-images' src={process.env.PUBLIC_URL + "assets/architectural/images/001_001.jpg"} />
                            <Card.Body>
                            <Card.Title className='architectural-modeling-footer-title'>Real Life <br /> Reference Photo</Card.Title>
                            </Card.Body>
                        </Card>
                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                            <Card.Img className='architectural-modeling-images' src={process.env.PUBLIC_URL + "assets/architectural/images/001_002.jpg"} />
                            <Card.Body>
                            <Card.Title className='architectural-modeling-footer-title'>Rendered Virtual Image <br /> From Artist -Created 3D Model</Card.Title>
                            </Card.Body>
                        </Card>
                    </CardGroup>

                    <CardGroup className='architectural-modeling-cardgroup mt-5'>
                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                            <Card.Img className='architectural-modeling-images' src={process.env.PUBLIC_URL + "assets/architectural/images/002_001.jpg"} />
                            <Card.Body>
                            <Card.Title className='architectural-modeling-footer-title'>Real Life <br /> Reference Photo</Card.Title>
                            </Card.Body>
                        </Card>
                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                            <Card.Img className='architectural-modeling-images' src={process.env.PUBLIC_URL + "assets/architectural/images/002_002.jpg"} />
                            <Card.Body>
                            <Card.Title className='architectural-modeling-footer-title'>Rendered Virtual Image <br /> From Artist -Created 3D Model</Card.Title>
                            </Card.Body>
                        </Card>
                    </CardGroup>
                </Card.Body>
            </Card>
            <Card className='text-center no-border rounded-0 py-5'>
                <Card.Body>
                    <Card.Subtitle className="industrial-modeling-subtitle py-4">Flyover View of Virtual McKissick Museum 3D Model</Card.Subtitle>
                        <div className='industrial-modeling-section'>
                            <video className='industrial-modeling-player container' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
                                <source src={process.env.PUBLIC_URL + "assets/architectural/video/McKissickMuseum_Flyover_2.mp4"} type="video/mp4"/>
                            </video>
                        </div>
                </Card.Body>
            </Card>
            <Card className='text-center no-border rounded-0 py-4'>
                <Card.Body>
                    <Card.Subtitle className="industrial-modeling-subtitle mt-md-5">Kuwait Skyline</Card.Subtitle>
                    <Card.Text className='kuwait-text'>
                        For a marketing video for an oil/gas development project offshore of Kuwait City, we recreated the city’s skyline and iconic bridge, as low - poly models suitable for 3D animation.
                    </Card.Text>
                        <div className='architectural-modeling-kuwait-section'>
                            <video className='architectural-modeling-kuwait-player container' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
                                <source src={process.env.PUBLIC_URL + "assets/architectural/video/kuwait_merge_with_grid.mp4"} type="video/mp4"/>
                            </video>
                        </div>
                </Card.Body>
            </Card>
        </Card>
    </>
  )
}

export default ArchitecturalModeling
